import { render } from "./ResultRegister.vue?vue&type=template&id=72b67cbe&scoped=true"
import script from "./ResultRegister.vue?vue&type=script&lang=js"
export * from "./ResultRegister.vue?vue&type=script&lang=js"

import "./ResultRegister.vue?vue&type=style&index=0&id=72b67cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b67cbe"]])

export default __exports__